import { Selection, Transaction } from 'prosemirror-state';

/**
 * Returns position where it's possible to place a decoration.
 */
export function getValidPos(tr: Transaction, pos: number) {
  const resolvedPos = tr.doc.resolve(pos);
  const backwardSelection = Selection.findFrom(resolvedPos, -1, true);
  // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
  const forwardSelection = Selection.findFrom(resolvedPos, 1, true);
  return backwardSelection
    ? backwardSelection.from
    : forwardSelection
    ? forwardSelection.from
    : pos;
}
